import React, { useState } from "react";
import styled from "styled-components";

interface FaqItem {
  id: number;
  question_en: string;
  question_me: string;
  answer_en: string;
  answer_me: string;
}

interface AccordionProps {
  faqs: FaqItem[];
  language: "EN" | "ME";
}

const AccordionWrapper = styled.div`
  width: 100%;
  max-width: 705px;
  margin: 0;
  padding: 0;
  @media (max-width: 992px) {
    margin: 0 auto;
  }
`;

const AccordionItem = styled.div`
  border-bottom: 2px solid var(--text-color);
`;

const Question = styled.div<{ $isOpen: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  margin-top: 44px;
  font-size: clamp(18px, 2.4vw, 24px);
  cursor: pointer;
  background: transparent;
  width: 100%;
`;

const Answer = styled.div<{ $isOpen: boolean }>`
  padding: 8px;
  font-size: clamp(18px, 2.4vw, 24px);
  background: transparent;
  display: ${({ $isOpen }) => ($isOpen ? "block" : "none")};
  width: 100%;
`;

const ExpandIcon = styled.span<{ $isOpen: boolean }>`
  transform: ${({ $isOpen }) => ($isOpen ? "rotate(180deg)" : "rotate(0)")};
  transition: transform 0.3s ease-in-out;
`;

const Accordion: React.FC<AccordionProps> = ({ faqs, language }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const getQuestion = (faq: FaqItem) =>
    language === "EN" ? faq.question_en : faq.question_me;

  const getAnswer = (faq: FaqItem) =>
    language === "EN" ? faq.answer_en : faq.answer_me;

  return (
    <AccordionWrapper>
      {faqs.map((item, index) => (
        <AccordionItem key={item.id}>
          <Question
            $isOpen={openIndex === index}
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
          >
            {getQuestion(item)}
            <ExpandIcon $isOpen={openIndex === index}>▼</ExpandIcon>
          </Question>
          <Answer $isOpen={openIndex === index}>{getAnswer(item)}</Answer>
        </AccordionItem>
      ))}
    </AccordionWrapper>
  );
};

export default Accordion;
